import React, { useState, useEffect, useRef } from 'react';
import '../NewPostForm.css';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Alert } from 'react-bootstrap';
import MentionTextarea from "./MentionTextarea";

const MySwal = withReactContent(Swal);

const frames = [
    { file: 'frame_heart.png', label: 'Srdce' },
    { file: 'frame_star.png', label: 'Hvězda' },
    { file: 'frame_glow.png', label: 'Záře' }
];

const filters = [
    { id: 'grayscale', label: 'Černobílý', unit: '%', min: 0, max: 100, default: 0 },
    { id: 'sepia', label: 'Sepia', unit: '%', min: 0, max: 100, default: 0 },
    { id: 'blur', label: 'Rozmazání', unit: 'px', min: 0, max: 10, default: 0 },
    { id: 'invert', label: 'Invert barvy', unit: '', min: 0, max: 1, default: 0, step: 0.1 },
    { id: 'saturate', label: 'Sytost', unit: '%', min: 0, max: 500, default: 100 },
    { id: 'contrast', label: 'Kontrast', unit: '%', min: 0, max: 300, default: 100 },
    { id: 'brightness', label: 'Jas', unit: '%', min: 0, max: 300, default: 100 },
];

const filtersData = filters;

const feelings = ['😊 Vesele', '😡 Naštvaně', '😂 Pobaveně', '🤢 Znechuceně', '😜 Hravě', '😚 Roztomile', '😍 Zamilovaně', '😱 Vystrašeně', '🤩 Natěšeně', '😢 Smutně', '🌟 Fantasticky', '😌 Uvolněně', '🎉 Slavnostně', '☕ Nostalgicky', '😌 Spokojeně', '🔥 Žhavě', '😴 Unaveně', '👀 Zvědavě', '🤔 Zamyšleně', '😔 Osaměle', '🥺 Nevinně', '🤤 Mlsně', '🥶 Zmrzle', '💩 Na hovno', '🤡 Jako debil', '👽 Úplně mimo', '🍬 Sladce', '🍻 Opile', '🍔 Hladově', '⚽️ Sportovně', '🌞 Jako sluníčko', '🧠 Bez mozku', '👑 Jako King', '👑 Jako Queen'];
const allowedEmojis = [
    '💖','💝','💘','❤️','😀','😄','😁','😆','🥹','😅','😂','🥲','😊','🙃','🙂','😇','😍','😌','😉','😘','😜','😝','😛','😎','🤓','🧐','🤨','🥸','🤩','🥳','🙂‍↕️','🥺','😩','😢','😭','😡','😱','😨','🤗','😓','😥','🫣','🤭','🤫','🫢','🫡','🤥','🫠','🫥','😬','🫨','🙄','😲','😴','🤕','😈', '🤖', '👻', '🧠', '💥', '🌈', '🔥', '🌙', '🍕', '🍷', '💀', '🎯', '🎮', '💤', '✨', '🚀', '📸'
];

const NewPostForm = ({ avatar, onNewPost  }) => {
    const modalRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [text, setText] = useState('');
    const [tags, setTags] = useState('');
    const [feeling, setFeeling] = useState('');
    const [frame, setFrame] = useState('');
    const [tagInput, setTagInput] = useState('');
    const [parsedTags, setParsedTags] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [trend, setTrend] = useState([]);
    const [goldTrend, setGoldTrend] = useState([]);
    const [customEmoji, setCustomEmoji] = useState(allowedEmojis[0]);
    const [customFeeling, setCustomFeeling] = useState('');
    const [showEditPanel, setShowEditPanel] = useState(false);

    const [image, setImage] = useState([]);
    const [imagePreview, setImagePreview] = useState([]);
    const [filterValues, setFilterValues] = useState([]);
    const [frames, setFrames] = useState([]);
    const [showEditPanelIndex, setShowEditPanelIndex] = useState(null);


    const updateFilterValue = (id, value) => {
        setFilterValues(prev => ({
            ...prev,
            [id]: value
        }));
    };

    const getCssFilterString = (filtersObj = filterValues) => {
        return Object.entries(filtersObj)
            .map(([id, value]) => {
                const f = filters.find(f => f.id === id);
                return `${id}(${value}${f.unit})`;
            })
            .join(' ');
    };

    useEffect(() => {
        const fetchTrend = async () => {
            try {
                const res = await fetch("https://api.fantasyworldtrpg.cz/echo/trend.php", {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' }
                });
                const data = await res.json();
                if (data.status === 'success' && Array.isArray(data.trend)) {
                    setTrend(data.trend);
                    setGoldTrend(data.gold);
                }
            } catch (error) {
                console.error('Chyba při načítání trendu:', error);
            }
        };

        fetchTrend();
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (open && modalRef.current && !modalRef.current.contains(e.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open]);


    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            setImage(files);
            setImagePreview(files.map(file => URL.createObjectURL(file)));
            setFilterValues(files.map(() => ({
                grayscale: 0,
                sepia: 0,
                blur: 0,
                invert: 0,
                saturate: 100,
                contrast: 100,
                brightness: 100
            })));
            setFrames(files.map(() => ""));
        }
    };


    const isValidPost = () => {
        return text.trim() !== '' || image !== null;
    };

    /* const uploadToImgur = async (base64Data) => {
        const formData = new FormData();
        formData.append("image", base64Data.split(',')[1]);

        const response = await fetch("https://api.imgur.com/3/image", {
            method: "POST",
            headers: {
                Authorization: "Client-ID 802dc556f40f25f"
            },
            body: formData
        });

        const data = await response.json();
        return data.success ? data.data.link : null;
    }; */

    const uploadToImgBB = async (base64Data) => {
        const form = new FormData();
        form.append('key', 'f2864012d8fdd791aceb36f194a58cb2');
        form.append('image', base64Data.split(',')[1]);

        const res = await fetch('https://api.imgbb.com/1/upload', {
            method: 'POST',
            body: form
        });
        const json = await res.json();
        return json.success ? json.data.url : null;
    };


    const toDataURL = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    };


    const generateFinalImage = async (base64, filters, frame) => {
        if (!base64) return null;

        const loadImage = (src) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(img);
                img.src = src;
            });
        };

        const baseImage = await loadImage(base64);
        const canvas = document.createElement('canvas');
        canvas.width = baseImage.width;
        canvas.height = baseImage.height;
        const ctx = canvas.getContext('2d');

        ctx.filter = Object.entries(filters)
            .map(([id, value]) => {
                const f = filtersData.find(f => f.id === id);
                return `${id}(${value}${f.unit})`;
            })
            .join(' ');

        ctx.drawImage(baseImage, 0, 0);

        if (frame) {
            const frameDataUrl = await toDataURL(`https://echo.fantasyworldtrpg.cz/img/${frame}`);
            const frameImg = await loadImage(frameDataUrl);
            ctx.drawImage(frameImg, 0, 0, canvas.width, canvas.height);
        }

        return canvas.toDataURL('image/png');
    };


    const handleTagInput = (e) => {
        const value = e.target.value;
        if (value.endsWith(' ')) {
            const tag = value.trim();
            if (tag && !parsedTags.includes(tag)) {
                setParsedTags([...parsedTags, tag]);
            }
            setTagInput('');
        } else {
            setTagInput(value);
        }
    };

    const removeTag = (tagToRemove) => {
        setParsedTags(parsedTags.filter(tag => tag !== tagToRemove));
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') setOpen(false);
    };

    useEffect(() => {
        if (open) {
            document.addEventListener('keydown', handleKeyDown);
        } else {
            document.removeEventListener('keydown', handleKeyDown);
        }
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [open]);

    const submitPost = async () => {
        if (!isValidPost()) {
            await MySwal.fire({
                icon: 'warning',
                title: 'Chybí obsah',
                text: 'Musíš napsat příspěvek nebo přidat obrázek.'
            });
            return;
        }

        if (isSubmitting) return;
        setIsSubmitting(true);

        const uid = localStorage.getItem("echo_user");
        if (!uid) {
            await MySwal.fire({
                icon: 'error',
                title: 'Chyba',
                text: 'Chybí identifikace uživatele.'
            });
            setIsSubmitting(false);
            return;
        }

        let imagesUrl = [];

        try {
            if (image && image.length > 0) {
                for (let idx = 0; idx < image.length; idx++) {
                    const file = image[idx];
                    const reader = new FileReader();
                    const fileLoad = await new Promise((resolve) => {
                        reader.onloadend = () => resolve(reader.result);
                        reader.readAsDataURL(file);
                    });

                    const finalImage = await generateFinalImage(fileLoad, filterValues[idx], frames[idx]);
                    if (finalImage) {
                        const imgurLink = await uploadToImgBB(finalImage);
                        if (imgurLink) {
                            imagesUrl.push(imgurLink);
                        }
                    } else {
                        console.error('Final image je null');
                    }
                }
            }

            // TEĎ - odeslání příspěvku na server
            const response = await fetch("https://api.fantasyworldtrpg.cz/echo/newpost.php", {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    uid: uid,
                    text,
                    tags: parsedTags.join(','),
                    feeling: feeling === 'custom' ? `${customEmoji} ${customFeeling}` : feeling,
                    images: imagesUrl
                })
            });

            const result = await response.json();

            if (result.success) {
                await MySwal.fire({
                    icon: 'success',
                    title: 'Hotovo!',
                    text: 'Příspěvek byl úspěšně přidán.'
                });

                // Resetování polí
                setText('');
                setImage([]);
                setImagePreview([]);
                setFilterValues([]);
                setFrames([]);
                setParsedTags([]);
                setFeeling('');
                setCustomFeeling('');
                setCustomEmoji(allowedEmojis[0]);
                setOpen(false);

                if (onNewPost) {
                    onNewPost(); // callback
                }

            } else {
                await MySwal.fire({
                    icon: 'error',
                    title: 'Chyba',
                    text: result.message || 'Nepodařilo se uložit příspěvek.'
                });
            }

        } catch (err) {
            console.error(err);
            await MySwal.fire({
                icon: 'error',
                title: 'Chyba',
                text: err.message || 'Nastala neočekávaná chyba.'
            });
        }

        setIsSubmitting(false);
    };


    return (
        <>
            <div className="d-flex align-items-center gap-2 mb-3" onClick={() => setOpen(true)} style={{ cursor: 'pointer' }}>
                <textarea type="text" style={{ resize: "none" }} className="form-control" value={text} placeholder="Co se ti honí hlavou?" readOnly />
            </div>
            {trend.length > 0 && (
                <div className="my-3">
                    <strong className="me-2">🔥 Trendy:</strong>
                    {goldTrend && (
                        <span className="badge bg-warning text-dark me-1">#{goldTrend}</span>
                    )}
                    {trend.map((t, i) => (
                        <span key={i} className="badge bg-danger me-1">#{t}</span>
                    ))}
                </div>
            )}

            {open && (
                <div className="new-post-overlay">
                    <button className="btn-close btn-close-white" onClick={() => setOpen(false)} />
                    <div className="new-post-inner" ref={modalRef}>
                        <h4 className="mb-3">Nový příspěvek</h4>

                        <textarea
                            className="form-control mb-2"
                            rows="4"
                            placeholder="Napiš něco..."
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                        />
                        {/*<MentionTextarea
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            placeholder="Napiš něco..."
                            rows={4}
                        />*/}

                        <input type="file" className="form-control mb-2" multiple onChange={handleImageChange} />
                        <Alert variant="warning">Uložení obrázků proběhne na servery Imgbb.com a je nutné dodržovat <a href="https://imgbb.com/tos" target="_blank">Imgbb TOS</a>! V opačném případě riskujete smázání!</Alert>

                        {imagePreview && imagePreview.map((src, idx) => (
                            <div key={idx} className="edit-wrapper mb-3">
                                <div style={{ position: "relative" }}>
                                    <img
                                        src={src}
                                        alt={`Náhled ${idx}`}
                                        className="img-fluid rounded w-100"
                                        style={{ filter: getCssFilterString(filterValues[idx]) }}
                                    />
                                    {frames[idx] && (
                                        <img
                                            src={`https://echo.fantasyworldtrpg.cz/img/${frames[idx]}`}
                                            alt="Rámeček"
                                            className="frame-overlay"
                                        />
                                    )}
                                </div>

                                <button
                                    className="btn btn-outline-danger btn-sm mt-2"
                                    onClick={() => setShowEditPanelIndex(showEditPanelIndex === idx ? null : idx)}
                                >
                                    {showEditPanelIndex === idx ? 'Skrýt úpravy' : 'Upravit obrázek'}
                                </button>

                                {showEditPanelIndex === idx && (
                                    <div className="edit-panel">
                                        <strong className="d-block mb-2">Úpravy obrázku:</strong>
                                        {filters.map((f) => (
                                            <div key={f.id} className="mb-2">
                                                <label className="form-label">
                                                    {f.label}: {filterValues[idx][f.id]}{f.unit}
                                                </label>
                                                <input
                                                    type="range"
                                                    min={f.min}
                                                    max={f.max}
                                                    step={f.step || 1}
                                                    value={filterValues[idx][f.id]}
                                                    onChange={(e) => {
                                                        const newValues = [...filterValues];
                                                        newValues[idx][f.id] = e.target.value;
                                                        setFilterValues(newValues);
                                                    }}
                                                    className="form-range"
                                                />
                                            </div>
                                        ))}
                                        <button
                                            className="btn btn-sm btn-outline-secondary mt-2"
                                            onClick={() => {
                                                const newValues = [...filterValues];
                                                filters.forEach(f => newValues[idx][f.id] = f.default);
                                                setFilterValues(newValues);
                                            }}
                                        >
                                            Obnovit filtry
                                        </button>
                                    </div>
                                )}
                            </div>
                        ))}


                        <div className="mb-3">
                            <label>Tagy:</label>
                            <div className="form-control d-flex flex-wrap gap-1">
                                {parsedTags.map((tag, index) => (
                                    <span key={index} className="badge bg-secondary position-relative">
                                        {tag}
                                        <button
                                            type="button"
                                            className="btn-close btn-close-white btn-sm position-absolute top-0 end-0"
                                            style={{ fontSize: '0.6rem' }}
                                            onClick={() => removeTag(tag)}
                                        />
                                    </span>
                                ))}
                                <input
                                    type="text"
                                    className="border-0 form-control flex-grow-1"
                                    placeholder="Napiš tagy a odděluj mezerou"
                                    value={tagInput}
                                    onChange={handleTagInput}
                                    style={{ outline: 'none' }}
                                />
                            </div>
                        </div>

                        <select className="form-select mb-3" value={feeling}
                                onChange={(e) => setFeeling(e.target.value)}>
                            <option value="">Žádný pocit</option>
                            <option value="custom">📝 Vlastní...</option>
                            {feelings.map((f) => (
                                <option key={f} value={f}>{f}</option>
                            ))}
                        </select>
                        {feeling === 'custom' && (
                            <div className="mb-3 d-flex gap-2">
                                <select className="form-select" value={customEmoji} onChange={(e) => setCustomEmoji(e.target.value)}>
                                    {allowedEmojis.map((emoji, i) => (
                                        <option key={i} value={emoji}>{emoji}</option>
                                    ))}
                                </select>
                                <input
                                    className="form-control"
                                    placeholder="Jak se cítíš?"
                                    value={customFeeling}
                                    onChange={(e) => setCustomFeeling(e.target.value)}
                                />
                            </div>
                        )}

                        <button className="btn btn-danger w-100" onClick={submitPost} disabled={isSubmitting}>
                            {isSubmitting ? 'Odesílání...' : 'Odeslat'}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default NewPostForm;
